import React, { useState } from "react"
import axios from 'axios'
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
// import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import {  Link } from "react-router-dom";
import withRouter from "../../Common/withRouter";
import { baseUrl } from "../../../api"; 
// users
import user1 from "../../../assets/images/users/user.png"
import useAuth from "../../../hooks/useAuth"
import { tokenStorage } from "../../../api/api-inteceptor"

const authChannel = new BroadcastChannel('auth-channel');

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  async function handleLogout() {
    await axios.post(`${baseUrl}/api/auth/logout`, {}, { withCredentials: true });
    authChannel.postMessage({ type: 'LOGOUT' });
    localStorage.clear();
    props.router.navigate("/login");
  }

  const getUserName = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return <span>{user.email}</span>;
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
          <div className="d-flex align-items-center text-center">
            <i className="mdi mdi-account-circle font-size-17 text-muted me-2 text-primary" />
            {getUserName()}
          </div>
          </DropdownItem>
          {/* <DropdownItem tag="a" href="#">
            <i className="mdi mdi-wallet font-size-17 text-muted align-middle me-1"/>
            {("My Wallet")}
          </DropdownItem>
          <DropdownItem className="d-flex align-items-center" to="#">
            <i className="mdi mdi-cog font-size-17 text-muted align-middle me-1"></i>
            {("Settings")}<span className="badge bg-success ms-auto">11</span></DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="mdi mdi-lock-open-outline font-size-17 text-muted align-middle me-1"/>
            {("Lock screen")}
          </DropdownItem>
          
          <div className="dropdown-divider"/> */}
          <DropdownItem onClick={handleLogout} className="dropdown-item text-danger">
          <div className="d-flex align-items-center text-center">
            <i className="mdi mdi-power font-size-17 text-muted me-2 text-danger"/>
            <span>Logout</span>
          </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(ProfileMenu)
);